import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/conversation/importer/conversationImporterActions'

export default importerReducers(actions)
